import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

export default function WebsiteButton({
  className,
  ...props
}: React.ComponentProps<"a">) {
  return (
    <Button
      asChild
      className={cn("flex h-[45px] w-full rounded-[23px]", className)}
      variant="cta"
    >
      <a rel="noopener noreferrer" target="_blank" {...props}>
        Visit website
      </a>
    </Button>
  );
}
